import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const footerLinks = [
  {"link": "/aboutus", "label": "About Us"},
  {"link": "/contactus", "label": "Contact Us"},
  {"link": "/faq", "label": "FAQ"},
  {"link": "/what-we-offer", "label": "What we Offer"},
  {"link": "/blogs", "label": "Blogs" },
  {"link": "/terms", "label": "Terms and Conditions"},
  {"link": "/privacy", "label": "Privacy Policy"},
  {"link": "/disclaimer", "label": "Disclaimer"},
];

const Footer = () => {
  const pageTitle = useSelector(state => state?.pageReducer?.pageTitle);

  return (
    <footer className="footer shadow-div">
      <div>
        {
          footerLinks?.map((item, index) => (
            <Link key={index} to={item.link} className={pageTitle?.toLowerCase() === item.label.toLowerCase() ? "footer-link-active" : "footer-link"}>
              {item.label}
            </Link>
          ))
        }
      </div>
    </footer>
  );
};

export default Footer;